<script lang="ts" setup>
import type { Coupon } from '@/models/coupon'

const props = defineProps<{
  coupon?: Coupon
}>()

const modals = useModalManager()
const couponStore = useCouponStore()

if (props.coupon)
  couponStore.setCoupon(props.coupon)

const { t } = useTranslation()

const route = useRoute()

// TODO: Check if there are more routes where coupon notification should not be shown
const isNotificationShown = computed(() => couponStore.notificationShown && !route.name.includes('warenkorb'))

const notAllowedRoutesForCouponButton = ['produkt-productName-pzn', 'pharmacyId-produkt-productName-pzn', 'produkte', 'pharmacyName-pharmacyPlz-pharmacyId-products']

const products = computed(() => {
  return couponStore.getCouponCookie()?.products ?? []
})

const link = computed(() => {
  return props.coupon?.landingPage || couponStore.getCouponCookie()?.landingPage
})

const showCouponButton = computed(() => {
  return products.value.length && link && !notAllowedRoutesForCouponButton.includes(route.name)
})

const couponProductsText = computed(() => products.value.length > 1 ? t('coupon.toProducts') : t('coupon.toProduct'))

const navigateToCouponLanding = () => {
  if (link.value)
    customNavigateTo(link.value as RouteLocationRaw)
}
</script>

<template>
  <IaAlert
    v-if="isNotificationShown"
    v-bind="$attrs"
    :action-text="showCouponButton ? couponProductsText : ''"
    closable
    type="info"
    full-width
    role="status"
    prevent-close
    @close="modals.show('CouponConfirm')"
    @action="navigateToCouponLanding"
  >
    {{ t("coupon.message") }}
  </IaAlert>
</template>
